import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { card, text, Space } from 'components/common';
import ROUTES from 'utils/constants/routes.json';
import { PrimaryButton } from 'components/common/button';

const { LogoCard } = card;
const { Title } = text;

const Container = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .space {
        text-align: center;
        width: 100%;

        a {
            width: 100%;
        }

        button {
            margin-top: 10px;
            width: 100%;
        }
    }
`;

type Props = {
    mainText: string;
    linkText: string;
};

const ContactSubmittedView: React.FC<Props> = ({ mainText, linkText }) => (
    <Container className="container">
        <LogoCard>
            <Space alignItems="center" direction="column">
                <Title level={3}>{mainText}</Title>
                <Link to={ROUTES.login_portal}>
                    <PrimaryButton>{linkText}</PrimaryButton>
                </Link>
            </Space>
        </LogoCard>
    </Container>
);

export default ContactSubmittedView;
